<button id="chatEjecutivo" #chatEjecutivo type="button" [disabled]="disable" [matBadge]="total != 0 ? total : ''" matBadgeColor="warn" (click)="openChat()" class="chat-bubble primary-button">
    <span class="material-symbols-outlined">chat</span>
    <input class="no-input label-chat" value="Conversa con tu ejecutivo" readonly>
</button>
